import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, vShow as _vShow, mergeProps as _mergeProps, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a8154b1"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "file-list"
}

import { t } from '@/plugins/i18n'
import { reactive, ref, watch } from 'vue'
import { Delete, Upload } from '@element-plus/icons-vue'
import { getSignNewApi } from '@/apis/oss'
import useFileUtils from '@/util/useFileUtils'
import { uid } from 'uid/dist/index.js'
import { ElMessage } from 'element-plus'
import { getRandomFileName, getBucketName } from '@/util/useUpload'


export default /*#__PURE__*/_defineComponent({
  props: {
  limit: {
    type: Number,
    default: 1
  },
  // 文件类型
  limitFile: {
    type: Object,
    default: () => ({
      accept: '.pdf'
    })
  },
  // 回显文件
  file: {
    type: Array,
    default: () => []
  },
  // 读取权限 true  允许读取
  readAuto: {
    type: Boolean,
    default: false
  },
  // 是否允许覆盖
  overwrite: {
    type: Boolean,
    default: false
  },
  // 业务类型
  bizType: {
    type: String,
    default: 'client'
  },
  path: {
    type: String,
    default: 'client/'
  },
  fileName: {
    type: String,
    default: ''
  },
  disabled: {
    type: Boolean,
    default: false
  }
},
  emits: ['change', 'getName'],
  setup(__props, { expose, emit }) {

const props = __props

const fileList: any = ref([])
watch(() => props.file, (value) => {
  console.log('watch', value)
  fileList.value = value
}, { immediate: true })

const { getExtension } = useFileUtils()
const host = ref('')
const uploadParams:any = reactive({
  name: '',
  key: '',
  policy: '',
  OSSAccessKeyId: '',
  success_action_status: 200,
  signature: ''
})
const totalFileList: any = ref([]) // 总文件
const delFile = () => {
  fileList.value = []
  handleChange()
}

const beforeUploadValidator: any = {
  '.pdf': (file: any) => {
    const { getExtension } = useFileUtils()
    const ext = getExtension(file.name)
    const limitList = ['pdf']
    if (!limitList.includes(ext)) {
      ElMessage.warning(t('上传文件只能是X格式').replace('X', limitList.join('/').toUpperCase()))
      return false
    }
    const size = file.size / 1024 / 1024
    if (size > 10) {
      ElMessage.warning('文件大小不超过10m')
      return false
    }
    return true
  },
  '.xls,.xlsx': (file: any) => {
    const { getExtension } = useFileUtils()
    const ext = getExtension(file.name)
    const limitList = ['xls', 'xlsx']
    if (!limitList.includes(ext)) {
      ElMessage.warning(t('上传文件只能是X格式').replace('X', limitList.join('/').toUpperCase()))
      return false
    }
    const size = file.size / 1024 / 1024
    if (size > 10) {
      ElMessage.warning('文件大小不超过10m')
      return false
    }
    return true
  },
  '.pdf,.xls,.xlsx': (file: any) => {
    const { getExtension } = useFileUtils()
    const ext = getExtension(file.name)
    const limitList = ['pdf', 'xls', 'xlsx']
    if (!limitList.includes(ext)) {
      ElMessage.warning(t('上传文件只能是X格式').replace('X', limitList.join('/').toUpperCase()))
      return false
    }
    const size = file.size / 1024 / 1024
    if (size > 10) {
      ElMessage.warning('文件大小不超过10m')
      return false
    }
    return true
  },
  '.pdf,.doc,.docx,.xls,.xlsx': (file: any) => {
    const { getExtension } = useFileUtils()
    const ext = getExtension(file.name)
    const limitList = ['pdf', 'doc', 'docx', 'xls', 'xlsx']
    if (!limitList.includes(ext)) {
      ElMessage.warning(t('上传文件只能是X格式').replace('X', limitList.join('/').toUpperCase()))
      return false
    }
    const size = file.size / 1024 / 1024
    if (size > 50) {
      ElMessage.warning('文件大小不超过50m')
      return false
    }
    return true
  },
  '.jpg,.jpeg,.png,.JPG,.JPEG,.PNG': (file: any) => {
    const { getExtension } = useFileUtils()
    const ext = getExtension(file.name)
    const limitList = ['jpg', 'jpeg', 'png', 'JPG', 'JPEG', 'PNG']
    console.log(ext)
    if (!limitList.includes(ext)) {
      ElMessage.warning(t('上传文件只能是X格式').replace('X', [...new Set(limitList.map(v => v.toUpperCase()))].join('/')))
      return false
    }
    const size = file.size / 1024 / 1024
    if (size > 50) {
      ElMessage.warning('文件大小不超过50m')
      return false
    }
    return true
  },
  '.jpg,.jpeg,.png,.JPG,.JPEG,.PNG,.pdf': (file: any) => {
    const { getExtension } = useFileUtils()
    const ext = getExtension(file.name)
    const limitList = ['jpg', 'jpeg', 'png', 'JPG', 'JPEG', 'PNG', 'pdf']
    console.log(ext)
    if (!limitList.includes(ext)) {
      ElMessage.warning(t('上传文件只能是X格式').replace('X', [...new Set(limitList.map(v => v.toUpperCase()))].join('/')))
      return false
    }
    const size = file.size / 1024 / 1024
    if (size > 50) {
      ElMessage.warning('文件大小不超过50m')
      return false
    }
    return true
  }
}

const beforeUpload = (file: any) => {
  emit('getName', file.name)
  console.log('beforeUpload', props.limitFile?.accept, file)
  if (beforeUploadValidator[props.limitFile?.accept](file)) {
    return getOssSign(file)
  }
  return false
}

const handleChange = (file: any) => {
  emit('change', fileList.value)
}

/**
 * 获取阿里云上传签名等参数
 */
const getOssSign = (file: any) => {
  return new Promise((resolve: any, reject: any): any => {
    getSignNewApi({
      bucketName: getBucketName(),
      path: props.path,
      type: props.overwrite ? 1 : 0
    })
      .then((res: any) => {
        const data = res.data
        // uploadParams.name = file.name
        // uploadParams.key = `${data.dir}${uid()}`
        // const ext = getExtension(file.name)
        // if (ext && ext.length > 0) {
        //   uploadParams.key = `${uploadParams.key}.${ext}`
        // }
        // uploadParams.policy = data.policy
        // uploadParams.OSSAccessKeyId = data.accessId
        // uploadParams.signature = data.signature
        const key = getRandomFileName({
          file,
          path: props.path,
          overwrite: props.overwrite,
          fileName: props.fileName,
          readAuto: props.readAuto,
          bizType: props.bizType
        })
        uploadParams.name = file.name
        uploadParams['Content-Disposition'] = file.name
        uploadParams.key = key
        uploadParams.policy = data.policy
        uploadParams.OSSAccessKeyId = data.accessId
        uploadParams.signature = data.signature
        uploadParams['x-oss-object-acl'] = props.readAuto ? 'public-read' : 'private'
        uploadParams['x-oss-forbid-overwrite'] = !!props.overwrite

        host.value = data.host.replace(/http[s]?:/, location.protocol)
        // this.customDomain = data.customDomain
        // // 上传后文件的访问url
        // file.url = `${this.customDomain}/${this.uploadParams.key}`
        console.log(`${data.host}/${uploadParams.key}`)
        file.url = `${data.host}/${uploadParams.key}`
        resolve(true)
      })
      .catch((error) => {
        console.error('error', error)
        reject(new Error())
      })
      .finally(() => {
        // do nothing
      })
  })
}
const handleClose = (key: any) => {
  fileList.value.splice(key, 1)
  emit('change', fileList.value)
}
expose({
  handleClose
})

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!

  return (_openBlock(), _createElementBlock("div", null, [
    (fileList.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fileList.value, (i, k) => {
            return (_openBlock(), _createBlock(_component_el_tag, {
              key: k,
              class: "mx-1 mr_10",
              closable: "",
              "disable-transitions": false,
              onClose: ($event: any) => (handleClose(k))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_tooltip, {
                  content: i.name,
                  placement: "top-start",
                  effect: "light"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(i.name), 1)
                  ]),
                  _: 2
                }, 1032, ["content"])
              ]),
              _: 2
            }, 1032, ["onClose"]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(_component_el_upload, _mergeProps({
      ref: (_value, _refs) => {
        _refs['uploadRef'] = _value
      },
      class: "uploader",
      accept: __props.limitFile?.accept,
      "before-upload": (beforeUpload as any),
      limit: __props.limit,
      action: host.value,
      data: _unref(uploadParams),
      "show-file-list": false,
      "file-list": fileList.value
    }, _ctx.$attrs, {
      onSuccess: handleChange,
      disabled: __props.disabled
    }), {
      trigger: _withCtx(() => [
        _renderSlot(_ctx.$slots, "trigger", _normalizeProps(_guardReactiveProps({ delFile: delFile })), () => [
          _createVNode(_component_el_button, { disabled: __props.disabled }, {
            default: _withCtx(() => [
              _createVNode(_component_el_icon, { class: "el-icon--left" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Upload))
                ]),
                _: 1
              }),
              _createTextVNode(_toDisplayString(_unref(t)('上传文件')), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      tip: _withCtx(() => [
        _renderSlot(_ctx.$slots, "tip")
      ]),
      _: 3
    }, 16, ["accept", "before-upload", "limit", "action", "data", "file-list", "disabled"]), [
      [_vShow, fileList.value.length < __props.limit]
    ])
  ]))
}
}

})